import {Button, Modal, Alert} from 'react-bootstrap';
import React from 'react';
import PropTypes from 'prop-types';

class CommonModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmMessage: props.confirmMessage || '',
            show: props.show || false,
            alertStyle: props.style || 'info',
            confirmCaption: props.confirmCaption || 'Confirm',
            closeCaption: props.closeCaption || 'Close',
        };

        this.onClose = this.onClose.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.props.show !== props.show) {
            this.setState({show: props.show});
        }
    }

    onClose(event) {
        const {preventClose, onClose} = this.props;
        if (preventClose) {
            return false;
        }
        onClose(event);
    }

    onConfirm(event) {
        const {onConfirm, onClose} = this.props;
        onConfirm(event);
        if (onClose) {
            onClose(event);
        }
    }

    render() {
        const {
            confirmMessage = '',
            show = false,
            alertStyle = 'info',
            confirmCaption = 'Confirm',
            closeCaption = 'Close',
            preventClose,
        } = this.state;
        const {title = '', bsSize, onlyContentVisible} = this.props;
        if (onlyContentVisible) {
            return (
                <Modal show={show} onHide={this.onClose} keyboard={false} className="visibility-hidden" bsSize={bsSize}>
                    <Modal.Body className="visibility-visible">
                        {this.props.children}
                    </Modal.Body>
                </Modal>
            );
        }
        return (
            <Modal show={show} onHide={this.onClose} keyboard={false} bsSize={bsSize}>
                <Modal.Header closeButton={!preventClose}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {confirmMessage &&
                    <Alert bsStyle={alertStyle}>
                        {confirmMessage}
                    </Alert>}
                    {this.props.children}
                </Modal.Body>
                {
                    confirmMessage && (
                        <Modal.Footer>
                            <div>
                                <Button onClick={this.onConfirm} bsStyle="primary">
                                    {confirmCaption}
                                </Button>
                                <Button onClick={this.onClose}>
                                    {closeCaption}
                                </Button>
                            </div>
                        </Modal.Footer>
                    )
                }
            </Modal>
        );
    }

}

CommonModal.propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    show: PropTypes.bool,
    alertStyle: PropTypes.string,
    onlyContentVisible: PropTypes.bool,
    preventClose: PropTypes.bool.isRequired,
    bsSize: PropTypes.string,
};

CommonModal.defaultProps = {
    onlyContentVisible: false,
    preventClose: false,
};

export default CommonModal;



// WEBPACK FOOTER //
// ./src/js/components/common/CommonModal.js